export default __webpack_public_path__ + "static/media/manuable_suministros.71bb0491.png";